/**
 * Validates and normalizes an internal app return URL.
 * Rejects external URLs, protocol-relative paths, and path traversal.
 */
export function sanitizeInternalReturnUrl(
  returnUrl: string | null | undefined,
  fallback: string
): string {
  if (!returnUrl || returnUrl === 'null' || returnUrl === 'undefined') {
    return fallback;
  }

  let decoded = returnUrl;
  try {
    decoded = decodeURIComponent(returnUrl);
  } catch {
    return fallback;
  }

  const trimmed = decoded.trim();
  if (
    !trimmed.startsWith('/') ||
    trimmed.startsWith('//') ||
    trimmed.includes('://') ||
    trimmed.includes('..')
  ) {
    return fallback;
  }

  return trimmed;
}
